// Auto-generated by scripts/generate-sitemap.mts. Do not edit by hand.
// Re-run via `npx nx run russrodgersbassguitar:generate-sitemap`.
// Per-route ISO 8601 dates derived from git log mtime (static routes)
// or from the post's frontmatter dateModified (blog routes).
// Used by SEOService to emit accurate JSON-LD WebPage.dateModified
// (matches the per-URL <lastmod> in src/sitemap.xml).

export const ROUTE_LASTMOD: Readonly<Record<string, string>> = {
  '/': '2026-09-14',
  '/about/bio': '2026-09-14',
  '/about/credits': '2026-06-21',
  '/about/discography': '2026-08-11',
  '/about/gear': '2026-09-14',
  '/about/performance': '2026-09-14',
  '/about/resume': '2026-09-11',
  '/bass-lessons/play-along-tracks': '2026-07-10',
  '/bass-lessons/testimonials': '2026-09-14',
  '/bass-lessons/what-i-teach': '2026-09-14',
  '/bass-lessons/zoom-setup': '2026-09-15',
  '/blog': '2026-09-14',
  '/blog/4-string-vs-5-string-vs-6-string-bass': '2026-08-10',
  '/blog/a-close-look-at-left-hand-positioning-on-bass-guitar': '2026-08-22',
  '/blog/a-new-way-to-look-at-scales-2': '2026-08-22',
  '/blog/adding-harmony-to-a-bass-line-2': '2026-08-22',
  '/blog/always-practice-the-way-you-are-going-to-play': '2026-08-22',
  '/blog/an-introduction-to-scales-on-the-bass-guitar': '2026-08-22',
  '/blog/anatomy-of-a-bass-line-2': '2026-08-22',
  '/blog/anatomy-of-an-exercise': '2026-08-22',
  '/blog/applying-triads-for-jazz-walking-bass-lines': '2026-08-22',
  '/blog/are-bass-lessons-worth-it': '2026-08-11',
  '/blog/attention-to-detail-with-your-bass-line-2': '2026-08-22',
  '/blog/bass-lessons-for-kids-vs-adults': '2026-08-10',
  '/blog/bebop-arpeggios': '2026-08-22',
  '/blog/composing-jazz-walking-bass-lines-using-triads': '2026-08-22',
  '/blog/difficulty/advanced': '2026-09-11',
  '/blog/difficulty/beginner': '2026-09-11',
  '/blog/difficulty/intermediate': '2026-09-11',
  '/blog/dissonant-notes-on-chord-sounds': '2026-08-22',
  '/blog/ear-training-a-way-to-work-on-chromatic-intervals': '2026-08-22',
  '/blog/ear-training-can-you-hear-me-now-2': '2026-08-22',
  '/blog/feeling-the-pulse': '2026-08-22',
  '/blog/fingering-choices-for-your-bass-line': '2026-08-22',
  '/blog/hand-conditioning-for-two-handed-tapping-on-bass-guitar': '2026-08-22',
  '/blog/how-long-does-it-take-to-learn-bass': '2026-08-09',
  '/blog/how-much-do-bass-lessons-cost': '2026-08-10',
  '/blog/how-to-stay-on-point-with-your-solos': '2026-08-22',
  '/blog/left-hand-form': '2026-08-22',
  '/blog/left-hand-muting-when-using-a-pick-2': '2026-08-22',
  '/blog/left-hand-string-to-string-movement-in-one-fret': '2026-08-10',
  '/blog/more-raw-lick-material': '2026-08-22',
  '/blog/more-right-hand-form-ideas-for-your-slap-bass-playing': '2026-08-22',
  '/blog/navigating-scale-notes-on-the-neck-2': '2026-08-22',
  '/blog/octave-slap-pattern-for-bass': '2026-08-10',
  '/blog/online-vs-in-person-bass-lessons': '2026-08-10',
  '/blog/open-strings-vs-fretted-notes': '2026-08-22',
  '/blog/organizing-triads-on-your-bass-neck': '2026-08-22',
  '/blog/prep-steps-for-working-on-your-note-reading': '2026-08-22',
  '/blog/raw-lick-material-a-way-to-organize-note-grouping': '2026-08-22',
  '/blog/reading-music-a-good-thing-to-do-2': '2026-08-22',
  '/blog/rhythm-reading-basics': '2026-08-22',
  '/blog/right-hand-form-choices-for-your-bass-playing-2': '2026-08-22',
  '/blog/right-hand-form-for-5-string-bass': '2026-08-10',
  '/blog/right-hand-form-for-6-string-bass': '2026-08-10',
  '/blog/right-hand-form-for-slap-bass-playing-2': '2026-08-22',
  '/blog/scale-note-navigation': '2026-08-22',
  '/blog/scales-on-bass-the-number-system-approach': '2026-08-12',
  '/blog/self-taught-vs-bass-lessons': '2026-08-10',
  '/blog/slap-bass-technique-fundamentals': '2026-08-10',
  '/blog/smart-choices-for-right-hand-fingering': '2026-08-22',
  '/blog/smart-fingering-choices-for-your-bass-lines': '2026-08-22',
  '/blog/switching-from-guitar-to-bass': '2026-08-09',
  '/blog/tag/arpeggios': '2026-09-11',
  '/blog/tag/bass-lines': '2026-09-11',
  '/blog/tag/choosing-lessons': '2026-09-11',
  '/blog/tag/comparison': '2026-09-11',
  '/blog/tag/fingering': '2026-09-11',
  '/blog/tag/fretboard-navigation': '2026-09-11',
  '/blog/tag/fundamentals': '2026-09-11',
  '/blog/tag/groove': '2026-09-11',
  '/blog/tag/hand-position': '2026-09-11',
  '/blog/tag/harmony': '2026-09-11',
  '/blog/tag/jazz': '2026-09-11',
  '/blog/tag/learning-approach': '2026-09-11',
  '/blog/tag/left-hand': '2026-09-11',
  '/blog/tag/line-construction': '2026-09-11',
  '/blog/tag/listening-skills': '2026-09-11',
  '/blog/tag/mindset': '2026-09-11',
  '/blog/tag/modes': '2026-09-11',
  '/blog/tag/muting': '2026-09-11',
  '/blog/tag/open-strings': '2026-09-11',
  '/blog/tag/practice-method': '2026-09-11',
  '/blog/tag/pulse': '2026-09-11',
  '/blog/tag/rhythm-reading': '2026-09-11',
  '/blog/tag/right-hand': '2026-09-11',
  '/blog/tag/scales': '2026-09-11',
  '/blog/tag/slap-bass': '2026-09-11',
  '/blog/tag/slap-technique': '2026-09-11',
  '/blog/tag/technique-basics': '2026-09-11',
  '/blog/tag/triads': '2026-09-11',
  '/blog/tag/vocabulary': '2026-09-11',
  '/blog/tag/walking-bass': '2026-09-11',
  '/blog/the-groove-denominator': '2026-08-10',
  '/blog/too-old-to-learn-bass': '2026-08-09',
  '/blog/topic/choosing-lessons': '2026-09-11',
  '/blog/topic/practice-and-mindset': '2026-09-11',
  '/blog/topic/repertoire-and-reading': '2026-09-11',
  '/blog/topic/technique': '2026-09-11',
  '/blog/topic/theory-and-harmony': '2026-09-11',
  '/blog/triads-and-bass-lines': '2026-08-22',
  '/blog/triads-and-chords-2': '2026-08-22',
  '/blog/triads-for-your-bass-lines': '2026-08-22',
  '/blog/using-a-pick': '2026-08-22',
  '/blog/walking-bass-lines-2': '2026-08-22',
  '/blog/what-are-modes': '2026-08-22',
  '/blog/what-is-groove-on-bass': '2026-08-10',
  '/blog/what-is-music-2': '2026-08-22',
  '/blog/when-to-stay-in-the-pocket': '2026-08-10',
  '/blog/why-triads-matter-for-bass-players': '2026-08-22',
  '/x-ploration-jazz': '2026-09-14',
};

export const SITE_LASTMOD = '2026-09-15';
